import type { Person } from '@/account/arcade-api';
import { UsageContainer } from '@/containers/UsageContainer';

/** The signed-in home page. */
export function HomeContainer({ person }: { person: Person }) {
  return <UsageContainer person={person} />;
}
